/**
 * Removes applicant data persisted in Web Storage (drafts such as `housingFormData`,
 * `profileFormFields_dev_all`, `profileCompletionStatus`, `financial.*`, `military.*`,
 * `registeredEmail`, ...) so it doesn't outlive the session on a shared machine.
 *
 * Called on logout / inactivity timeout (GlobalContext) and whenever the API answers 401
 * (services/api.ts). Only non-sensitive dev-tool UI prefs are preserved. This never navigates,
 * so calling it from the 401 path cannot cause a redirect loop.
 */
const PRESERVED_KEYS = new Set<string>([
    "devDrawerVisible", // DevTaskbar drawer open/closed (localStorage)
    "dev_god_mode", // dev-only God Mode toggle (sessionStorage)
]);

function clearStore(store: Storage | undefined): void {
    if (!store) return;
    try {
        for (const key of Object.keys(store)) {
            if (!PRESERVED_KEYS.has(key)) store.removeItem(key);
        }
    } catch {
        // Storage can throw (privacy mode / disabled storage) — nothing to clear then.
    }
}

export function clearApplicantStorage(): void {
    if (typeof window === "undefined") return;
    clearStore(window.localStorage);
    clearStore(window.sessionStorage);
}
